export enum ApprovalState {
  APPROVED = 'APPROVED',
  DISABLED = 'DISABLED',
  EDITING = 'EDITING',
  PENDING_KYC = 'PENDING_KYC',
  PENDING = 'PENDING',
  DELETED = 'DELETED',
  REJECTED = 'REJECTED',
  ACTIVATE = 'ACTIVATE',
}
